module.exports = __webpack_public_path__ + "static/img/pc_pd_v2_3.c875d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_v2_3.png
// module id = /xST
// module chunks = 0